"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snippetBubbleSide = exports.snippetBorderColor = exports.snippetReasonColor = exports.snippetBubbleColor = exports.claimTabColor = exports.claimChartLabel = exports.claimTabLabel = exports.isClaimTab = exports.CLAIM_TABS = void 0;
exports.withCurlyQuotes = withCurlyQuotes;
const types_1 = require("@repo/types");
const copy_1 = require("./copy");
const palette_1 = require("./palette");
exports.CLAIM_TABS = [
    types_1.SNIPPET_TYPE.CLAIMEDFACTS,
    types_1.SNIPPET_TYPE.OPINIONSTATEMENTS,
    types_1.SNIPPET_TYPE.DUBIOUSCLAIMS,
];
const TAB_KEY = {
    [types_1.SNIPPET_TYPE.CLAIMEDFACTS]: 'facts',
    [types_1.SNIPPET_TYPE.OPINIONSTATEMENTS]: 'opinions',
    [types_1.SNIPPET_TYPE.DUBIOUSCLAIMS]: 'claims',
};
const isClaimTab = (type) => exports.CLAIM_TABS.includes(type);
exports.isClaimTab = isClaimTab;
const claimTabLabel = (tab) => copy_1.ANALYSIS_COPY.claimTabs[TAB_KEY[tab]];
exports.claimTabLabel = claimTabLabel;
const claimChartLabel = (tab) => copy_1.ANALYSIS_COPY.claimChart[TAB_KEY[tab]];
exports.claimChartLabel = claimChartLabel;
const claimTabColor = (tab) => palette_1.ANALYSIS_PALETTE.chart[TAB_KEY[tab]];
exports.claimTabColor = claimTabColor;
/**
 * Snippet bubble fill. The website tints every other bubble starting with the
 * first (`:nth-child(odd)`), leaving the rest on the neutral surface.
 */
const snippetBubbleColor = (tab, index) => index % 2 === 0
    ? palette_1.ANALYSIS_PALETTE.snippet[TAB_KEY[tab]].tint
    : palette_1.ANALYSIS_PALETTE.surfaceAlt;
exports.snippetBubbleColor = snippetBubbleColor;
const snippetReasonColor = (tab, index) => index % 2 === 0
    ? palette_1.ANALYSIS_PALETTE.snippet[TAB_KEY[tab]].reasonTint
    : palette_1.ANALYSIS_PALETTE.surfaceAlt;
exports.snippetReasonColor = snippetReasonColor;
const snippetBorderColor = (tab) => palette_1.ANALYSIS_PALETTE.snippet[TAB_KEY[tab]].border;
exports.snippetBorderColor = snippetBorderColor;
/** Even bubbles sit on the right with a right tail, odd ones on the left. */
const snippetBubbleSide = (index) => index % 2 === 0 ? 'right' : 'left';
exports.snippetBubbleSide = snippetBubbleSide;
const OPEN = '“';
const CLOSE = '”';
/** Wrap a quote in curly quotes exactly once, whatever it arrived with. */
function withCurlyQuotes(text) {
    const hasOpen = text.includes(OPEN);
    const hasClose = text.includes(CLOSE);
    if (hasOpen && hasClose)
        return text;
    if (hasOpen)
        return `${text}${CLOSE}`;
    if (hasClose)
        return `${OPEN}${text}`;
    const startsWithQuote = text.startsWith('"');
    const endsWithQuote = text.endsWith('"') && text.length > 1;
    if (startsWithQuote && endsWithQuote)
        return `${OPEN}${text.slice(1, -1)}${CLOSE}`;
    if (startsWithQuote)
        return `${OPEN}${text.slice(1)}${CLOSE}`;
    if (endsWithQuote)
        return `${OPEN}${text.slice(0, -1)}${CLOSE}`;
    return `${OPEN}${text}${CLOSE}`;
}
